import React from "react";
import { AutoTable } from "@components";
import { useTheme } from "@mui/material";
import { useTableConfig } from "./useTableConfig";
import { supportedCSVImportBanks } from "./constants";

export const BanksTable = () => {
  const config = useTableConfig();
  const theme = useTheme();

  return (
    <AutoTable
      settings={config}
      data={supportedCSVImportBanks}
      sx={{
        border: `1px solid ${theme.palette.border.secondary}`,
        borderRadius: "10px",
        ".MuiTableCell-root": {
          backgroundColor: theme.palette.background.subtle,
          color: theme.palette.text.secondary,
        },
      }}
    />
  );
};
